import { render, staticRenderFns } from "./MessagesView.vue?vue&type=template&id=2b811fde&scoped=true&"
import script from "./MessagesView.vue?vue&type=script&lang=js&"
export * from "./MessagesView.vue?vue&type=script&lang=js&"
import style0 from "./MessagesView.vue?vue&type=style&index=0&id=2b811fde&scoped=true&lang=css&"
import style1 from "./MessagesView.vue?vue&type=style&index=1&id=2b811fde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b811fde",
  null
  
)

export default component.exports